import { createAction, props } from '@ngrx/store';

export const showToaster = createAction(
  '[App Page]  Show Toaster',
  props<{ message: string; toasterType: string; duration?: number; isDismissible?: boolean }>(),
);
